export default __webpack_public_path__ + "static/media/create.853c2111.svg";